import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import logo4bpm from "..//Logo_4bpm.png";
import "./cabecalho.css";

const Cabecalho = () => {
  return (
    <header className="cabecalho-modern">
      <Container fluid>
        <Row className="align-items-center">
          <Col xs={10} md={8}>
            <div className="cabecalho-title">
              <span className="cabecalho-subtitle">Polícia Militar do Maranhão</span>
              <h1>Boletim Eletrônico · 4º BPM</h1>
            </div>
          </Col>

          <Col xs={2} md={4} className="text-end">
            <img
              src={logo4bpm}
              alt="Logo do 4º BPM"
              className="cabecalho-logo"
            />
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default Cabecalho;
